export default __webpack_public_path__ + "static/media/Mark-6-HUD-00.95e0cc86.jpg";